import React, { Children } from "react";
import classNames from "classnames";
import "./style.css";
import "@gouvfr/dsfr/dist/component/link/link.css";
import "@gouvfr/dsfr/dist/component/button/button.css";
import "@gouvfr/dsfr/dist/component/callout/callout.css";
var Callout = function (props) {
    var children = props.children, icon = props.icon, borderColor = props.borderColor, className = props.className;
    var title = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return "props" in child && child.props.__TYPE === "CalloutTitle";
    });
    var body = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return "props" in child && child.props.__TYPE === "CalloutBody";
    });
    var footer = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return "props" in child && child.props.__TYPE === "CalloutFooter";
    });
    var _classNames = classNames("dsmj-callout", "fr-callout", "".concat(icon), "fr-callout--".concat(borderColor), className);
    return (React.createElement("div", { className: _classNames },
        title,
        body,
        footer));
};
export default Callout;
